module.exports = __webpack_public_path__ + "static/media/Item_Weapon_M249_C.c7d0204d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_M249_C.png
// module id = 400
// module chunks = 0